module.exports = __webpack_public_path__ + "static/lighthouse-d644358e5a4dcd8d4f47acb8f58a153d.jpg";